module.exports = __webpack_public_path__ + "img/LOGO_NAEGA_DI.f8a1916e.svg";